/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { FCMToken } from '../models/FCMToken';
import type { PatchedPushToStartToken } from '../models/PatchedPushToStartToken';
import type { PushToStartToken } from '../models/PushToStartToken';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class FcmtokenService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns FCMToken
     * @throws ApiError
     */
    public fcmtokenCreate({
        requestBody,
    }: {
        requestBody: FCMToken,
    }): CancelablePromise<FCMToken> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/fcmtoken/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns void
     * @throws ApiError
     */
    public fcmtokenDestroy({
        token,
    }: {
        /**
         * A unique value identifying this FCM Token.
         */
        token: string,
    }): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/api/fcmtoken/{token}/',
            path: {
                'token': token,
            },
        });
    }

    /**
     * Public API to update push_to_start_token for an existing FCMToken.
     * No authentication required.
     * @returns PushToStartToken
     * @throws ApiError
     */
    public fcmtokenPushToStartPartialUpdate({
        requestBody,
    }: {
        requestBody?: PatchedPushToStartToken,
    }): CancelablePromise<PushToStartToken> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/api/fcmtoken/push-to-start/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

}
